import { SET_NO_DATA_TITLE } from './SettingNoDataTitleAction';
import { SET_NO_DATA_TITLE_CONFIG } from "./SettingNoDataTitleAction"

const initialState = {
  data: "",
  config: {
      font: "Verdana",
      color: "#126faf",
      fontSize: 14,
      textDecoration: false,
      fontWeight: false,
      fontStyle: false,
  }
};

/**
 * Reducer for managing noDataTitle configuration in dashboard settings section.
 */
const noDataTitleReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_NO_DATA_TITLE:
      return { ...state, data: action.payload };
    case SET_NO_DATA_TITLE_CONFIG:
      return { ...state, config: action.payload }
    default:
      return state;
  }
};

export default noDataTitleReducer;
